import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo, createElement } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { FormControl, FormLabel, FormControlLabel, Radio, Autocomplete } from "@mui/material";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import { DatePicker } from "../../../../../components/date-pickers/date-picker/date-picker.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import { MenuItem } from "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import { TextField } from "../../../../../components/text-field/text-field.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { DATE_FORMATS } from "../../../../../constants/date/date.js";
import { isValid } from "date-fns";
import { InsuranceType, GenderType } from "../../appointment-details.types.js";
import { BirthdayIcon } from "../../assets/icons/Birthday.js";
import { InsuranceIcon } from "../../assets/icons/Insurance.js";
import { MailIcon } from "../../assets/icons/Mail.js";
import { PatientIcon } from "../../assets/icons/Patient.js";
import { PhoneIcon } from "../../assets/icons/Phone.js";
import { LABEL_OFFSET } from "../appointment-form/appointment-form.constants.js";
import { FieldsGroup, FieldWrapper, StyledRadioGroup } from "./new-patient-form.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/x-date-pickers";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "../../../../../type/Translations.js";
import "date-fns/locale";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "color-alpha";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
const NewPatientForm = ({ labels, language }) => {
  const {
    form: { patient },
    gender,
    insurance
  } = labels;
  const { control } = useFormContext();
  const options = useMemo(
    () => Object.values(InsuranceType).map((value) => ({
      label: insurance[value],
      value
    })),
    []
  );
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs(FieldsGroup, { children: [
      /* @__PURE__ */ jsx(FieldWrapper, { children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "patient.genderType",
          control,
          render: ({ field: { onChange, value, ref, ...field }, fieldState: { error, isTouched } }) => {
            const showError = !!error && isTouched;
            return /* @__PURE__ */ jsxs(FormControl, { error: showError, children: [
              /* @__PURE__ */ jsx(FormLabel, { children: patient.form.gender.label }),
              /* @__PURE__ */ jsx(StyledRadioGroup, { ...field, value: value ?? "", ref, row: true, children: Object.values(GenderType).map((type) => /* @__PURE__ */ jsx(
                FormControlLabel,
                {
                  value: type,
                  control: /* @__PURE__ */ jsx(Radio, { color: "primary", value: type }),
                  onChange,
                  label: gender[type]
                },
                type
              )) })
            ] });
          }
        }
      ) }),
      /* @__PURE__ */ jsx(FieldWrapper, { children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "patient.phoneNumber",
          control,
          render: ({ field: { ref, ...field }, fieldState: { error, isTouched } }) => {
            const showError = !!error && isTouched;
            return /* @__PURE__ */ jsx(
              TextField,
              {
                ...field,
                fullWidth: true,
                label: patient.form.phoneNumber.label,
                required: true,
                inputRef: ref,
                labelOffset: LABEL_OFFSET,
                error: showError,
                helperText: showError && patient.form.phoneNumber.error,
                InputProps: {
                  startAdornment: /* @__PURE__ */ jsx(PhoneIcon, {})
                }
              }
            );
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(FieldsGroup, { children: [
      /* @__PURE__ */ jsx(FieldWrapper, { children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "patient.firstName",
          control,
          render: ({ field: { ref, ...field }, fieldState: { error, isTouched } }) => {
            const showError = !!error && isTouched;
            return /* @__PURE__ */ jsx(
              TextField,
              {
                ...field,
                fullWidth: true,
                required: true,
                autoFocus: true,
                label: patient.form.firstName.label,
                inputRef: ref,
                labelOffset: LABEL_OFFSET,
                error: showError,
                helperText: showError && patient.form.firstName.error,
                InputProps: {
                  startAdornment: /* @__PURE__ */ jsx(PatientIcon, {})
                }
              }
            );
          }
        }
      ) }),
      /* @__PURE__ */ jsx(FieldWrapper, { children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "patient.lastName",
          control,
          render: ({ field: { ref, ...field }, fieldState: { error, isTouched } }) => {
            const showError = !!error && isTouched;
            return /* @__PURE__ */ jsx(
              TextField,
              {
                ...field,
                fullWidth: true,
                required: true,
                label: patient.form.lastName.label,
                inputRef: ref,
                labelOffset: LABEL_OFFSET,
                error: showError,
                helperText: showError && patient.form.lastName.error,
                InputProps: {
                  startAdornment: /* @__PURE__ */ jsx(PatientIcon, {})
                }
              }
            );
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx(FieldsGroup, { children: /* @__PURE__ */ jsx(
      Controller,
      {
        name: "patient.dateOfBirth",
        control,
        render: ({ field: { value, ref, ...field }, fieldState: { error, isTouched } }) => {
          const showError = (!!error || !isValid(value)) && isTouched;
          return /* @__PURE__ */ jsx(
            DatePicker,
            {
              ...field,
              value,
              disableFuture: true,
              closeOnSelect: false,
              views: ["year", "month", "day"],
              inputRef: ref,
              reduceAnimations: true,
              openTo: "year",
              language,
              format: DATE_FORMATS.DAY_MONTH_YEAR,
              labels: {
                cancelButtonLabel: labels.buttons.cancel,
                okButtonLabel: labels.buttons.save
              },
              slotProps: {
                popper: {
                  placement: "top-end"
                },
                textField: {
                  error: showError,
                  required: true,
                  label: patient.form.birthDay.label,
                  // @ts-expect-error - missing type for labelOffset
                  labelOffset: LABEL_OFFSET,
                  InputProps: {
                    startAdornment: /* @__PURE__ */ jsx(BirthdayIcon, {}),
                    onBlur: field.onBlur
                  },
                  fullWidth: true,
                  helperText: DATE_FORMATS.DAY_MONTH_YEAR.toUpperCase()
                }
              }
            }
          );
        }
      }
    ) }),
    /* @__PURE__ */ jsx(FieldsGroup, { children: /* @__PURE__ */ jsx(
      Controller,
      {
        name: "patient.email",
        control,
        render: ({ field: { ref, ...field }, fieldState: { error, isTouched } }) => {
          var _a, _b;
          const showError = !!error && isTouched;
          return /* @__PURE__ */ jsx(
            TextField,
            {
              ...field,
              fullWidth: true,
              label: (_a = patient.form.email) == null ? void 0 : _a.label,
              inputRef: ref,
              error: showError,
              helperText: showError && ((_b = patient.form.email) == null ? void 0 : _b.error),
              labelOffset: LABEL_OFFSET,
              InputProps: {
                startAdornment: /* @__PURE__ */ jsx(MailIcon, {})
              }
            }
          );
        }
      }
    ) }),
    /* @__PURE__ */ jsx(FieldsGroup, { children: /* @__PURE__ */ jsx(
      Controller,
      {
        name: "patient.insuranceType",
        control,
        render: ({ field: { value, onChange, ...field }, fieldState: { error, isTouched } }) => {
          const selectedOption = options.find((option) => option.value === value);
          const showError = !!error && isTouched;
          return /* @__PURE__ */ jsx(
            Autocomplete,
            {
              ...field,
              options,
              onChange: (_, option) => onChange(option == null ? void 0 : option.value),
              value: selectedOption,
              defaultValue: selectedOption,
              disableClearable: true,
              fullWidth: true,
              renderOption: (props, option) => /* @__PURE__ */ createElement(
                MenuItem,
                {
                  ...props,
                  selected: option.value === value,
                  key: option.value
                },
                option.label
              ),
              renderInput: ({ InputLabelProps, InputProps, ...params }) => /* @__PURE__ */ jsx(
                TextField,
                {
                  ...params,
                  label: patient.form.insurance.label,
                  error: showError,
                  helperText: showError && patient.form.insurance.error,
                  labelOffset: LABEL_OFFSET,
                  required: true,
                  InputProps: {
                    ...InputProps,
                    startAdornment: /* @__PURE__ */ jsx(InsuranceIcon, {})
                  },
                  InputLabelProps: {
                    ...InputLabelProps,
                    shrink: !!value
                  }
                }
              )
            }
          );
        }
      }
    ) })
  ] });
};
export {
  NewPatientForm
};
